import React from "react";
import { useLenis } from "../hooks/useLenis";
import { Seo } from "../components/Seo";
import { Header } from "../components/landing/Header";
import { MobileStickyCTA } from "../components/landing/MobileStickyCTA";
import { HeroCinematic } from "../components/landing/HeroCinematic";
import { CredibilityStrip } from "../components/landing/CredibilityStrip";
import { OperatingProblem } from "../components/landing/OperatingProblem";
import { Architecture } from "../components/landing/Architecture";
import { Outcomes } from "../components/landing/Outcomes";
import { Marquee } from "../components/landing/Marquee";
import { Simulation } from "../components/landing/Simulation";
import { Toolkit } from "../components/landing/Toolkit";
import { TrainingSample } from "../components/landing/TrainingSample";
import { Differentiation } from "../components/landing/Differentiation";
import { Personas } from "../components/landing/Personas";
import { Qualification } from "../components/landing/Qualification";
import { LearnerInfo } from "../components/landing/LearnerInfo";
import { Enrolment } from "../components/landing/Enrolment";
import { LeadForm } from "../components/landing/LeadForm";
import { FAQ } from "../components/landing/FAQ";
import { FinalCTA } from "../components/landing/FinalCTA";
import { Footer } from "../components/landing/Footer";

export default function LandingPage() {
  useLenis();
  return (
    <div className="bg-offwhite">
      <Seo path="/" />
      <Header />
      <main>
        <HeroCinematic />
        <CredibilityStrip />
        <OperatingProblem />
        <Architecture />
        <Outcomes />
        <Marquee />
        <Simulation />
        <Toolkit />
        <TrainingSample />
        <Differentiation />
        <Personas />
        <Qualification />
        <Enrolment />
        <LearnerInfo />
        <LeadForm />
        <FAQ />
        <FinalCTA />
      </main>
      <Footer />
      <MobileStickyCTA />
    </div>
  );
}
